import './themeDefaults';

export default ({ modal }) => ({
  root: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: 40,
    background: 'transparent',
    height: 40,
    border: 0,
    cursor: 'grab',
    '& svg': {
      fill: modal.gripColor
    },
    '&:focus': {
      outline: 'none'
    }
  }
});
